'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DimensionConfig = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayTo = require('d2-utilizr/lib/arrayTo');

var _arrayTo2 = _interopRequireDefault(_arrayTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DimensionConfig = exports.DimensionConfig = undefined;

exports.DimensionConfig = DimensionConfig = function DimensionConfig() {
    var t = this;

    // service
    var i18nManager;

    // uninitialized
    var dimensions = {};

    // dimension name map
    var dimensionNameDimensionMap = {
        'dx': 'data',
        'co': 'category',
        'pe': 'period',
        'ou': 'organisationUnit'
    };

    var defaultDataType = 'aggregated_values';

    // data type
    t.dataType = {
        'aggregated_values': 'AGGREGATED_VALUES',
        'individual_cases': 'EVENTS'
    };

    t.dataTypeUrl = {
        'AGGREGATED_VALUES': '/events/aggregate',
        'EVENTS': '/events/query'
    };

    // value type
    t.valueType = {
        'numeric_types': ['NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE'],
        'text_types': ['TEXT', 'LONG_TEXT', 'LETTER', 'PHONE_NUMBER', 'EMAIL'],
        'boolean_types': ['BOOLEAN', 'TRUE_ONLY'],
        'date_types': ['DATE', 'DATETIME'],
        'aggregate_aggregatable_types': ['BOOLEAN', 'TRUE_ONLY', 'TEXT', 'LONG_TEXT', 'LETTER', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE', 'NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'COORDINATE'],
        'tracker_aggregatable_types': ['NUMBER', 'UNIT_INTERVAL', 'PERCENTAGE', 'INTEGER', 'INTEGER_POSITIVE', 'INTEGER_NEGATIVE', 'INTEGER_ZERO_OR_POSITIVE', 'BOOLEAN', 'TRUE_ONLY']
    };

    // setter
    var setDimensions = function setDimensions() {
        dimensions = _extends(dimensions, {
            data: {
                value: 'data',
                name: i18nManager.get('data') || 'Data',
                id: 'dx',
                dimensionName: 'dx',
                objectName: 'dx'
            },
            category: {
                name: i18nManager.get('assigned_categories') || 'Assigned categories',
                id: 'co',
                dimensionName: 'co',
                objectName: 'co'
            },
            indicator: {
                value: 'indicator',
                name: i18nManager.get('indicators') || 'Indicators',
                dimensionName: 'dx',
                objectName: 'in'
            },
            dataElement: {
                value: 'dataElement',
                name: i18nManager.get('data_elements') || 'Data elements',
                dimensionName: 'dx',
                objectName: 'de'
            },
            operand: {
                value: 'operand',
                name: i18nManager.get('operand') || 'Operand',
                dimensionName: 'dx',
                objectName: 'dc'
            },
            dataSet: {
                value: 'dataSet',
                name: i18nManager.get('data_sets') || 'Data sets',
                dimensionName: 'dx',
                objectName: 'ds'
            },
            eventDataItem: {
                value: 'eventDataItem',
                name: i18nManager.get('event_data_items') || 'Event data items',
                dimensionName: 'dx',
                objectName: 'di'
            },
            programIndicator: {
                value: 'programIndicator',
                name: i18nManager.get('program_indicators') || 'Program indicators',
                dimensionName: 'dx',
                objectName: 'pi'
            },
            period: {
                value: 'period',
                name: i18nManager.get('periods') || 'Periods',
                id: 'pe',
                dimensionName: 'pe',
                objectName: 'pe'
            },
            fixedPeriod: {
                value: 'period'
            },
            relativePeriod: {
                value: 'relativePeriod'
            },
            startEndDate: {
                value: 'dates',
                name: i18nManager.get('start_end_dates')
            },
            organisationUnit: {
                value: 'organisationUnit',
                name: i18nManager.get('i18n.organisation_units') || 'Organisation units',
                id: 'ou',
                dimensionName: 'ou',
                objectName: 'ou'
            },
            dimension: {
                value: 'dimension'
                //objectName: 'di'
            },
            value: {
                value: 'value'
            }
        });
    };

    // init
    t.init = function () {
        setDimensions();
    };

    // prototype
    t.add = function (param) {
        (0, _arrayFrom2.default)(param).forEach(function (dimension) {
            dimension.dimensionName = dimension.dimensionName || dimension.id;
            dimension.objectName = dimension.objectName || dimension.id;

            dimensions[dimension.id] = dimension;
        });
    };

    t.get = function (name) {
        var map = dimensionNameDimensionMap;

        return name ? dimensions[name] || dimensions[map[name]] : dimensions;
    };

    t.getDimensionNameMap = function () {
        var map = {};

        for (var name in dimensions) {
            if (dimensions.hasOwnProperty(name)) {
                map[dimensions[name].dimensionName] = dimensions[name];
            }
        }

        return map;
    };

    t.getObjectNameMap = function () {
        var map = {};

        for (var name in dimensions) {
            if (dimensions.hasOwnProperty(name)) {
                map[dimensions[name].objectName] = dimensions[name];
            }
        }

        return map;
    };

    t.getDefaultDataType = function () {
        return t.dataType[defaultDataType];
    };

    t.setI18nManager = function (manager) {
        i18nManager = manager;
    };
};

DimensionConfig.prototype.applyTo = function (modules) {
    var t = this;

    (0, _arrayTo2.default)(modules).forEach(function (module) {
        module.dimensionConfig = t;
    });
};
//# sourceMappingURL=DimensionConfig.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/config/DimensionConfig.js
 ** module id = 125
 ** module chunks = 0 1
 **/